$(function(){
    $('#search-box').typeahead({
        hint: true,
        highlight: true,
        minLength: 3
    },{
        name: 'suggestions',
        source: function (query, process) {
            $.getJSON($i.contextPath + '/service/search/suggestions?prefix=' + encodeURIComponent(query) + '&max=5', function(data){
                var output = $.map(data, function (string) { return { value: string }; });
                process(output);
            });
        }
    });
    $('.twitter-typeahead').css('direction', $('html').attr('dir'));
});
